import React from "react"
import { constants } from "helpers"
import Navbar from "../Navbar/Navbar"

const currentYear = new Date().getFullYear()

const Copy: React.FC = () => {
  return (
    <div className="flex flex-col mb:space-y-4 ds:flex-row ds:items-center ds:justify-between">
      <div className="text-accent-grey-100 text-caption-12">{`©${currentYear} ${constants.companyName}`}</div>
      {/* Desktop navbar - only show on desktop */}
      <div className="mb:hidden">
        <Navbar />
      </div>
    </div>
  )
}

export default Copy
